<template>
  <div>
    <div class="home-bg">
      <div class="theme">
        <h3>农村信用通</h3>
        <div>扶持农村发展，助力农村致富</div>
        <el-button @click="goTo()">信息采集</el-button>
      </div>
    </div>
    <div class="news">
      <div class="title">
        <span class="left"><img src="@/assets/flag.png" alt=""> 新闻公告</span>  
        <span class="right" v-if="list.length" @click="$router.push('NewsList')">查看更多<img src="@/assets/more.png" alt=""> </span>  
      </div>
      <!-- 列表 -->
      <div class="notice" v-if="list.length">
        <div class="list">
          <div class="leftImg">
            <swiper class="main_container" :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback">
              <swiper-slide v-for="(item, index) in Imglist" :key="index">
                <img class="imgItem" :src="item" alt="" >
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>  
          </div>
          <div style="height: 392px;">
            <div class="list-content" v-for="item in listFirst" :key="item.id" @click="detail(item)">
              <div class="list-title">{{item.title}}</div>
              <div class="list-info" v-html="item.description"></div>
            </div>
          </div>
        </div>
        <div class="lists">
          <div class="list-content" v-for="item in listEnd" :key="item.id" @click="detail(item)">
            <div :class="[item.imgUrl ?'content-left':'content-lefts']" >
              <div class="list-title">{{item.title}}</div>
              <div class="list-info" v-html="item.description"></div>
              <div class="date">发布时间：<span>{{item.publicTime}}</span></div>
            </div>
            <div v-if="item.imgUrl" class="rightImg">
              <img  :src="item.imgUrl" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 登录态 -->
    <Login :tab="tab" @chooseTab='chooseTab' />
    <!-- 消息通知 -->
    <Notice />
  </div>
</template>
<script>
import Login from "../Login";
import Notice from './components/Notice'
import demoImg from "@/assets/BAYW-1.png"
import { sessionStore } from "@/utils/data-management";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import publicFun from "@/utils/publicFunction";
export default {
  name: "home",
  components: {
    Login,
    Swiper,
    SwiperSlide,
    Notice
  },
  data() {
    return {
      tab: 1,
      active: 1,
      Imglist: ['http://kf.vpclub.cn/group1/M00/0B/E9/rBAFJF8b6--AcNgSABRHMesp0fY484.jpg'],
      list: [],
      listFirst: [],
      listEnd: [],
      demoImg: demoImg,
      search: {
        pageNum: 1,
        pageSize: 100,
        userId: this.$store.state.userInfo.id,
        areaConfigId: this.$store.state.cityArea.areaConfigId,
        systemConfigName:'xyt' //改改改  xyt
      },
      swiperOption: {
        autoplay: true, 
        slidesPerView: 1, 
        pagination: {
          el: '.swiper-pagination'
        }
      }
    };
  },
  computed: {
    status() {
      return this.$store.state.infoStatus;
    },
    show() {
      return this.$store.state.token;
    },
    cityArea() {
      return this.$store.state.cityArea     
    },
  },
  watch: {
    show(newVal, oldVal) {      
      this.tab = sessionStore.get("toLoginType") * 1
    },    
    cityArea(newVal, oldVal) {
      if (newVal) {
        this.search.areaConfigId = newVal.areaConfigId
        this.list = []
        this.listFirst = []
        this.listEnd = []
        this.getDataList();
      }
    }
  },
  methods: {
    chooseTab(v){
      this.tab = v * 1
    },
    goTo() {
      if( this.show && this.show != 'show' ){
        if (this.$store.state.userInfo.personVertification) {
          this.$router.push({ name: 'InfoCollection'})
        } else {
          this.$store.state.vertification = true;
        } 
      } else {
        this.$store.dispatch('getToken', 'show')
      }
    },
    callback() {
      console.log('this is current swiper instance object', this.swiper)
      this.swiper.slideTo(3, 1000, false)
    },
    detail(row){
      this.$router.push({name: 'MyNoticeDetail', query:{ id: row.id}})
    },
    img(index) {
      if (this.active == index) {
        return require(`@/assets/home-tab${index}-w.png`);
      } else {
        return require(`@/assets/home-tab${index}-b.png`);
      }
    },
    getDataList() {
      this.$api.user.queryProjectNotices(this.search).then(res => {
        if (res.code == 1000) {
          this.list = res.data
          if (this.list.length) {
            if (this.list.length > 3) {
              this.listFirst = this.list.slice(0,3)
              this.listEnd = this.list.slice(3)
            } else {
              this.listFirst = this.list
              this.listEnd = []
            }
            this.listFirst.forEach((item)=> {
              if(item.imgUrl){
                this.Imglist.push(...item.imgUrl.split(',')) 
              }
            })
          }
        }
      })
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getDataList();
    this.$store.dispatch('getUserInfo')
  }
};
</script>
<style lang="scss" scoped>
.home-bg {
  width: 100%;
  height: 575px;
  background: url("~@/assets/home-bg3.png") no-repeat;
  background-size:cover;
  overflow: hidden;
  .theme {
    width: 1200px;
    margin: 169px auto 0;
    color:  #fff;
    font-family: PingFangSC-Regular;
    h3 {
      font-weight: 400;
      font-size: 68px;
      margin-bottom: 29px;
    }
    div {
      font-size: 29px;
      margin-bottom: 30px;
    }
    .el-button {
      width: 260px;
      height: 64px;
      font-size: 24px;
      background: #FF7A00;
      border-radius: 32.5px;
      border: none;
      color: #fff;
    }
  }
}
.news {
  text-align: center;
  background: #fff;
  padding-top: 50px;
  .title {
    width: 1200px;
    color: #F88209;
    margin: 45px auto 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 15px;
    border-bottom: 1px solid #FFF1E8;
    .left{
      font-size: 18px;
      display: inline-block;
      vertical-align: middle;
      img{
        width: 24px;
        height: 26px;
        display: inline-block;
        vertical-align: middle;
      }
    }
    .right{
      font-size: 14px;
      background: rgba(228,136,77,0.15);
      border-radius: 1px;
      padding: 5px 10px;
      cursor: pointer;
      img{
        width: 9px;
        height: 9px;
        display: inline-block;
      }
    }
  }
  .notice {
    padding-bottom: 20px;
    .list {
      width: 1200px;
      margin: 25px auto 45px;
      display: flex;
      align-items:center;
      justify-content: space-between;
      .leftImg{
        width: 536px;
        height: 392px;
        margin-right: 35px;
        overflow: hidden;
         display: flex;
          justify-content: center;
          align-items: center;
        .imgItem{
          width: 536px;
          height: 392px;
          display: block;
          margin: auto; 
          object-fit: cover;
        }
      }
      .list-content{
        width: 628px;
        padding: 40px 0 5px;
        border-bottom: 1px dashed #D6D6D6;
        text-align: justify;
        font-size: 0;
        cursor: pointer;
        .list-title{
          font-size: 20px;
          color: #1F2022;
          padding-bottom: 15px;
        }
        .list-info{
          font-size: 16px;
          color: #525457;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-bottom: 15px;
        }
      }
      .list-content:first-child{
        padding-top: 0;
      }
    }
    .lists{
      width: 1200px;
      margin: 25px auto 45px;
      .list-content{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
        padding-bottom: 30px;
        border-bottom: 2px solid #DFDFDF;
        cursor: pointer;
        .content-left,.content-lefts{
          text-align: justify;
          .list-title{
            font-size: 20px;
            color: #292929;
            padding-top: 5px;
            padding-bottom: 30px;
          }
          .list-info{
            font-size: 17px;
            color: #676767;
          }
          .date{
            padding: 17px 0 0;
            font-size: 16px;
            color: #8F8F8F;
          }
        }
        .rightImg{
          width: 360px;
          height: 228px;
          margin-left: 64px;
          overflow: hidden;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          img{
            width:auto;
            height:auto;
            max-width:100%;
            max-height:100%;
            object-fit: cover;
          }
        }
        .content-lefts{
          width: 100% !important;
        }
      }
    }
  }
}
</style>